export enum LEGAL_TYPE {
  PRIVACY_POLICY = 'Privacy policy',
  TERMS_OF_USE = 'Terms of use',
  SHIFT_WORKER_TERMS_OF_SERVICE = 'Shift worker terms of service',
}
